import PropTypes from 'prop-types';

import {
    MenuItemType as SourceMenuItemType,
    MenuType as SourceMenuType
} from 'SourceType/Menu.type';

export const MenuItemType = PropTypes.shape({
    SourceMenuItemType,
    url: PropTypes.string
});

MenuItemType.children = PropTypes.objectOf(MenuItemType);

export const MenuType = SourceMenuType;
